import { Injectable } from '@angular/core';
import { AuthErrorPresenter, AuthLogger } from '@core-features/auth';

/**
 * The default `AuthLoggerService` and `AuthHostErrorPresenterService` depend on
 * `MessengerService`, `DsSnackbarService` and `TranslateService`. Pulling that
 * stack into an externally embedded widget would tie it to PALDESK host
 * infrastructure, so the widget logs to the console instead.
 */
@Injectable()
export class PalchatAuthLogger implements AuthLogger {
  /** Traces are dropped: an embedded widget must not fill the host console. */
  logTrace(): void {
    return;
  }

  logWarning(message: string, detailObject?: unknown): void {
    console.warn('[palchat auth]', message, detailObject ?? '');
  }

  logError(message: string, detailObject?: unknown): void {
    console.error('[palchat auth]', message, detailObject ?? '');
  }
}

/**
 * A failed sign-in leaves the widget in anonymous mode, which is a supported
 * state rather than an error worth interrupting the host page for.
 */
@Injectable()
export class PalchatAuthErrorPresenter implements AuthErrorPresenter {
  displayError(translationMarker?: string): void {
    console.warn('[palchat auth] sign-in unavailable', translationMarker ?? '');
  }
}
